import { Component, input, output } from '@angular/core';
import { DateTime } from 'luxon';

import {
  NoRecordsComponent,
  SortIconComponent,
  ViewIconButtonComponent,
} from '@sandbox-platform/shared-ui';

import {
  CommissionPaymentDTO,
  PAYMENT_METHOD_LABELS,
  PAYMENT_TYPE_LABELS,
} from '../../../../types/commission-payment.types';

@Component({
  standalone: true,
  imports: [NoRecordsComponent, SortIconComponent, ViewIconButtonComponent],
  selector: 'lib-commission-payment-list-table',
  templateUrl: './commission-payment-list-table.component.html',
})
export class CommissionPaymentListTableComponent {
  payments = input.required<CommissionPaymentDTO[]>();
  canView = input<boolean>(false);
  sortBy = input<string>('payment_date');
  sortDirection = input<'asc' | 'desc'>('desc');

  viewPayment = output<CommissionPaymentDTO>();
  sortChange = output<{ sortBy: string; sortDirection: 'asc' | 'desc' }>();

  protected onHeaderClick(field: string): void {
    const newDirection =
      this.sortBy() === field && this.sortDirection() === 'asc'
        ? 'desc'
        : 'asc';
    this.sortChange.emit({ sortBy: field, sortDirection: newDirection });
  }

  protected paymentTypeLabel(type: string): string {
    return (
      PAYMENT_TYPE_LABELS[type as keyof typeof PAYMENT_TYPE_LABELS] ?? type
    );
  }

  protected paymentTypeClass(type: string): string {
    switch (type) {
      case 'payment':
        return 'bg-green-100 text-green-800';
      case 'reversal':
        return 'bg-red-100 text-red-800';
      case 'adjustment':
        return 'bg-blue-100 text-blue-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  }

  protected paymentMethodLabel(method: string): string {
    return (
      PAYMENT_METHOD_LABELS[method as keyof typeof PAYMENT_METHOD_LABELS] ??
      method
    );
  }

  protected formatDate(date?: string | Date): string {
    if (!date) return '-';
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    if (Number.isNaN(dateObj.getTime()) || dateObj.getFullYear() <= 1)
      return '-';
    return DateTime.fromJSDate(dateObj).toFormat('dd-MMM-yyyy');
  }

  protected formatMoney(amountMinor?: number, currency = 'KES'): string {
    if (amountMinor === undefined || amountMinor === null) return '-';
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency,
    }).format(amountMinor / 100);
  }
}
